import { useEffect, useState } from 'react';
import CardFrom, { CardFormChildrenConfig, CardFormConfig } from '../../component/card/card-from';
import i18n from '../../i18n';
import ButtonComponent from '../../component/button/button.component';
import LSM from '../../modules/cache/tool-local-storage';
import { LOCAL_STORAGE_KEYS } from '../../modules/cache/local-storage.constant';
import { Admin } from '../../models';
import apiManage from '../../request';
import GlobalNotification from '../../component/common/snackbar';
import _ from 'lodash';
import { Box } from '@mui/material';

export default function FiskalySetting() {
    // 原始用户信息
    const [userInfo, setUserInfo] = useState<Admin>({})
    // 编辑后的用户信息
    const [editUserInfo, setEditUserInfo] = useState<Pick<Admin, 'fiskaly_organization_key' | 'fiskaly_organization_secret' | 'fiskaly_live_organization_key' | 'fiskaly_live_organization_secret'>>({});
    useEffect(() => {
        init()
    }, [])

    const init = () => {
        getUserInfo();
    }

    const getUserInfo = async () => {
        const account = LSM.get(LOCAL_STORAGE_KEYS.ACCOUNT) || {};
        const userInfo = await apiManage.get_admin_id_id(account._id || '');
        if (!userInfo?.error) {
            setUserInfo(userInfo);
            setEditUserInfo(_.pick(userInfo, ['fiskaly_organization_key', 'fiskaly_organization_secret', 'fiskaly_live_organization_key', 'fiskaly_live_organization_secret']));
        }
    }
    /**
     * 表单回调
     * @param value
     * @param key
     */
    const onFormChange = (value: string | boolean, key: string) => {
        editUserInfo[key] = value
        setEditUserInfo({ ...editUserInfo })
    }


    /**
     * 保存表单
     */
    const onFormSave = async () => {
        const newAccount = {
            _id: userInfo._id,
            ...editUserInfo,
        }

        const result = await apiManage.patch_admin_id_admin(newAccount)
        if (result && !result?.error) {
            GlobalNotification.success(`${i18n.t('dish_book_msg_save_success')}`);
            getUserInfo()
        } else {
            GlobalNotification.error(`${i18n.t('dish_book_msg_save_failed')}`);
        }
    }


    // 表单
    const formData: CardFormChildrenConfig[] = [
        {
            key: 'fiskaly_live_organization_key',
            label: 'Fiskaly API KEY (Live)',
            xs: 12,
            md: 12,
            comType: 'INPUT'
        },
        {
            key: 'fiskaly_live_organization_secret',
            label: 'Fiskaly API SECRET (Live)',
            xs: 12,
            md: 12,
            comType: 'INPUT'
        },
        {
            key: 'fiskaly_organization_key',
            label: 'Fiskaly API KEY (Test)',
            xs: 12,
            md: 12,
            comType: 'INPUT'
        },
        {
            key: 'fiskaly_organization_secret',
            label: 'Fiskaly API SECRET (Test)',
            xs: 12,
            md: 12,
            comType: 'INPUT'
        },
    ]

    // 表单
    const cardConfig: CardFormConfig[] = [{
        md: 12,
        columnSpacing: { xs: 2 },
        rowSpacing: 4,
        key: 'base_setting_title',
        title: i18n.t('base_setting_title'),
        actionRender: (
            <>
                <ButtonComponent
                    action='SAVE'
                    handleClick={() => onFormSave()}
                    async={true}
                />
            </>

        ),
        children: formData.map((item) => (
            {
                ...item,
                inputIsEdited: userInfo[item.key] !== editUserInfo[item.key],
                onChange: (e) => onFormChange(e.target.value, item.key),
                handleChangeCountry: (value) => onFormChange(value, item.key),
            }
        ))
    }]

    return (
        <Box sx={{ maxWidth: 600 }}>
            <CardFrom
                config={cardConfig}
                data={editUserInfo}
            />
        </Box>
    )
}